import { isFarFetchUser } from '../../lib/util';
const filterOptions = [
  { name: 'score', label: 'Rating', options: ['great', 'good', 'it\'s a start', 'not good enough', 'we avoid'] },
  { name: 'environment', label: 'Environment', options: ['great', 'good', 'it\'s a start', 'not good enough', 'very poor'] },
  { name: 'labour', label: 'Labour', options: ['great', 'good', 'it\'s a start', 'not good enough', 'very poor'] },
  { name: 'animal', label: 'Animal', options: ['great', 'good', 'it\'s a start', 'not good enough', 'very poor', 'not applicable'] },
  {
    name: 'categories',
    label: 'Categories',
    options: [
      'Tops',
      'Bottoms',
      'Denim',
      'Dresses & Playsuits',
      'Sweaters & Knitwear',
      'Outerwear',
      'Suits',
      'Basics & Intimates',
      'Sleepwear',
      'Swimwear',
      'Maternity',
      'Plus Size',
      'Shoes',
      'Bags',
      'Jewellery & Watches',
      'Accessories',
      'Activewear',
    ],
  },
  { name: 'price', label: 'Price', options: [1, 2, 3, 4] },
  { name: 'segment', label: 'Segment', options: ['kids', 'mens', 'womens'] },
];
if (isFarFetchUser()) {
  filterOptions.push({ name: 'farfetch', label: 'Farfetch', options: ['yes', 'no'] });
}
export default filterOptions;



// WEBPACK FOOTER //
// ./src/components/Zalando/FilterOptions.js